import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "error"]

  validate(event) {
    if (this.hasSelection()) {
      this.hideError()
    } else {
      event.preventDefault()
      this.showError()
    }
  }

  update() {
    if (this.hasSelection()) {
      this.hideError()
    }
  }

  hasSelection() {
    return this.checkboxTargets.some((checkbox) => checkbox.checked)
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden")
    }
  }
}
